import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
// Axios
import { Chart, registerables } from "chart.js";
import { QueryClient, QueryClientProvider } from "react-query";
// Apps
import { MetronicI18nProvider } from "./_metronic/i18n/Metronici18n";
/**
 * TIP: Replace this style import with rtl styles to enable rtl mode
 *
 * import './_metronic/assets/css/style.rtl.css'
 **/
import "react-loading-skeleton/dist/skeleton.css";
import "nouislider/dist/nouislider.css";
import "./_metronic/assets/sass/style.scss";
import "./_metronic/assets/sass/plugins.scss";
import "./_metronic/assets/sass/style.react.scss";
import "./app/global.scss";
import { AppRoutes } from "./app/routing/AppRoutes";
import { AuthProvider } from "./app/modules/auth";
import { ThemeModeProvider } from "./_metronic/partials/layout/theme-mode/ThemeModeProvider";
import { loadRuntimeConfig } from "./app/config/runtimeConfig";
/**
 * Creates `axios-mock-adapter` instance for provided `axios` instance, add
 * basic Metronic mocks and returns it.
 *
 * @see https://github.com/ctimmerm/axios-mock-adapter
 */
/**
 * Inject Metronic interceptors for axios.
 *
 * @see https://github.com/axios/axios#interceptors
 */
Chart.register(...registerables);

const queryClient = new QueryClient();
const container = document.getElementById("root");

async function bootstrap() {
	if (!container) {
		return;
	}

	const root = createRoot(container);

	try {
		await loadRuntimeConfig();
	} catch (error) {
		console.error(error);
		root.render(
			<div id="splash-screen" className="splash-screen">
				<span className="mb-3">Não foi possível carregar a configuração do sistema.</span>
				<button className="btn btn-primary" onClick={() => window.location.reload()}>
					Tentar novamente
				</button>
			</div>
		);
		return;
	}

	root.render(
		<StrictMode>
			<QueryClientProvider client={queryClient}>
				<MetronicI18nProvider>
					<ThemeModeProvider>
						<AuthProvider>
							<AppRoutes />
						</AuthProvider>
					</ThemeModeProvider>
				</MetronicI18nProvider>
			</QueryClientProvider>
		</StrictMode>
	);
}

bootstrap();
